import Category from "../Category";
import MenuItemBuilder from "../MenuItemBuilder";
import {addOnOptions} from "../AddOnOptions";

export default new Category('Special Luncheon', 'images/categories/lunch.jpg')
    .setDescription('Monday thru Saturday from 11:00 AM to 3:00 PM. Served w/ Steamed Rice or Fried Rice and An Egg Roll')
    .addMenuItem(new MenuItemBuilder('Chicken or Pork Lo Mein (Lunch Special)', 6.95)
        .setOptions('Chicken Lo Mein (Lunch Special)', 'Pork Lo Mein (Lunch Special)')
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp or Beef Lo Mein (Lunch Special)', 6.95)
        .setOptions('Shrimp Lo Mein (Lunch Special)', 'Beef Lo Mein (Lunch Special)')
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Sweet & Sour Chicken or Pork (Lunch Special)', 6.95)
        .setOptions('Sweet & Sour Chicken (Lunch Special)', 'Sweet & Sour Pork (Lunch Special)')
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Pork w/ Mixed Vegetable (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Mongolian Beef (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Beef w/ Broccoli (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Pepper Steak w/ Onion (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Beef w/ Mixed vegetable (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Hunan Chicken or Beef (Lunch Special)', 6.95)
        .setSpicy(true).setServingOptions(2)
        .setOptions('Hunan Chicken (Lunch Special)', 'Hunan Beef (Lunch Special)').setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Chicken w/ Garlic Sauce (Lunch Special)', 6.95)
        .setSpicy(true).setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Moo Goo Gai Pan (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Chicken w/ Broccoli (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Chicken w/ Cashew Nuts (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Chicken w/ Mixed Vegetable (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Kung Pao Chicken (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('General Tso\'s Chicken (Lunch Special)', 6.95)
        .setSpicy(true).setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Sesame Chicken (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Teriyaki Chicken (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Mixed Vegetable (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Broccoli w/ Garlic Sauce (Lunch Special)', 6.95)
        .setSpicy(true).setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Lobster Sauce (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Broccoli (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Mixed Vegetable (Lunch Special)', 6.95)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Garlic Sauce (Lunch Special)', 6.95)
        .setSpicy(true).setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Hot & Spicy Shrimp (Lunch Special)', 6.95)
        .setSpicy(true).setServingOptions(2).setAddOns(...addOnOptions).build())